import {DeviceSlotId, DeviceSlotReservationId, ProjectId, UserId} from '../ids';
import {Schedule} from '../schedule';

export abstract class DeviceSlotReservation{
    constructor(public readonly id: DeviceSlotReservationId, public readonly userId: UserId, public readonly slotId: DeviceSlotId, public readonly projectId: ProjectId, public readonly isActive: boolean, public readonly nextActiveAt?: string){};

    /** needs to return a type-specific description */
    abstract toNiceString(): string;
    abstract beginsIn(millis: number): boolean;
}

export function deviceSlotReservationFromBackendObject(r: any): DeviceSlotReservation {
    switch (r['type']) {
        case "absolute": return new AbsoluteDeviceSlotReservation(r['id'], r['userId'], r['slotId'], r['projectId'], r['isActive'], r['begin'], r['end'], r['nextActiveAt']);
        case "scheduled": return new ScheduledDeviceSlotReservation(r['id'], r['userId'], r['slotId'], r['projectId'], r['isActive'], r['schedule'], r['until'], r['nextActiveAt']);
        default: {
            //throw an Error, which will likely cause Issues as it probably happens in a Subscriber. See to it that we never trigger this!
            const msg = "Unknown Slot Reservation type, type '" + r['type'] + "' is not supported";
            console.error(msg);
            throw new Error(msg);
        }
    }
}

export function reservationSortingFunction(a: DeviceSlotReservation, b: DeviceSlotReservation): number {
    if (a.nextActiveAt && b.nextActiveAt) {
        return a.nextActiveAt.localeCompare(b.nextActiveAt);
    } else if (!a.nextActiveAt && !b.nextActiveAt) {
        return a.id.localeCompare(b.id);
    } else if (!a.nextActiveAt) {
        return -1;
    } else {
        return 1;
    }
}



//TODO: move to own file
export class AbsoluteDeviceSlotReservation extends DeviceSlotReservation{
    constructor(public readonly id: DeviceSlotReservationId,
                public readonly userId: UserId,
                public readonly slotId: DeviceSlotId,
                public readonly projectId: ProjectId,
                public readonly isActive: boolean,
                public readonly begin: string,
                public readonly end: string,
                public readonly nextActiveAt?: string) {
        super(id, userId, slotId, projectId, isActive, nextActiveAt)
    }

    toNiceString(): string {
        //TODO: MomentJS only installs pipes at the moment, which is bad
        let from = new Date(this.begin).toLocaleString();
        let to = new Date(this.end).toLocaleString();
        return "from " + from + " to " + to;
    }

    beginsIn(millis: number): boolean {
        let start = new Date(this.begin).getTime();
        let current = new Date().getTime();
        let difference = start - current;
        if (0 < difference && difference <= millis) {
            return true;
        } else if (difference < 0) {
            const msg = "The current time is later than the reservation time!";
            throw new Error(msg);
        } else {
            return false;
        }
    }
}

//TODO: move to own file
export class ScheduledDeviceSlotReservation extends DeviceSlotReservation {
    constructor(public readonly id: DeviceSlotReservationId,
                public readonly userId: UserId,
                public readonly slotId: DeviceSlotId,
                public readonly projectId: ProjectId,
                public readonly isActive: boolean,
                public readonly schedule: Schedule,
                public readonly until?: string,
                public readonly nextActiveAt?: string) {
        super(id, userId, slotId, projectId, isActive, nextActiveAt)
    }

    toNiceString(): string {
        if (this.nextActiveAt) {
            return "scheduled next at " + this.nextActiveAt + (this.schedule.optEventDuration ? "for " + this.schedule.optEventDuration : "");
        } else {
            return "";
        }
    }

    beginsIn(millis: number): boolean {
        if (this.nextActiveAt) {
            let start = new Date(this.nextActiveAt).getTime();
            let current = new Date().getTime();
            let difference = start - current;
            if (0 < difference && difference <= millis) {
                return true;
            } else if (difference < 0) {
                const msg = "The current time is later than the reservation time! Try to reload the page.";
                throw new Error(msg);
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}
